import React from "react";
import { Answer, Enrolment } from "../../../../stores/EnrolmentStore/Types";
import { ActiveTab, CourseOverviewState } from "../types";

interface Props {
  activeTab: ActiveTab;
  answers: Answer[];
  enrolment: Enrolment;
  state: CourseOverviewState;
}

const LivesPanel = ({ activeTab, answers, enrolment, state }: Props) => {
  const remainingLives = enrolment?.lives_count || 0;
  // Every life this enrolment was ever issued, straight from the server. It
  // used to be inferred by counting answers in the `failed` state, but a failed
  // answer is a lesson got wrong, not a life spent -- the life goes when the
  // learner chooses to retake, and retaking cancels the failed answer, so it
  // leaves the list being counted. Anyone who had actually spent lives read
  // back as "2 of 2".
  const totalLives = Math.max(enrolment?.lives_total ?? 0, remainingLives);
  const hearts = Array.from({ length: totalLives || remainingLives });

  return (
    <section
      className="tabpanel"
      id="panel-lives"
      role="tabpanel"
      aria-labelledby="tab-lives"
      tabIndex={0}
      hidden={activeTab !== "lives"}
    >
      <div className="lives">
        <div className="lives__hearts" aria-hidden="true">
          {hearts.map((_, index) => (
            <span
              className={`h ${index >= remainingLives ? "spent" : ""}`}
              key={index}
            >
              <svg aria-hidden="true">
                <use href="#ic-heart" />
              </svg>
            </span>
          ))}
        </div>
        <h2>
          {state === "complete"
            ? `You finished with ${remainingLives} lives to spare`
            : `You have ${remainingLives}${
                totalLives ? ` of ${totalLives}` : ""
              } lives left`}
        </h2>
        <p>
          Spend a life to retake a lesson you got wrong. If you run out, you can
          still finish the course and pass. You just won't be able to retake
          lessons after that.
        </p>
      </div>
    </section>
  );
};

export default LivesPanel;
